import React from 'react';
import findIndex from 'lodash/findIndex';

import { FlexDivSpaceBetweenCenter } from 'resources/styles/display';
import SVButton from 'components/elements/SVButton';

// ==== Types ====

interface Page {
  name: string;
  [key: string]: any; // for any additional page-specific properties
}

interface FooterNavigationModel {
  isFirstPage: boolean;
  isLastPage: boolean;
  currentPage: Page;
  visiblePages: Page[];
}

interface FooterNavigationProps {
  model: FooterNavigationModel;
  onPageChanged: (page: Page) => void;
}

// ==== Component ====

const FooterNavigation: React.FC<FooterNavigationProps> = ({
  model,
  onPageChanged,
}) => {
  const {
    isFirstPage,
    isLastPage,
    visiblePages,
    currentPage,
  } = model;

  const currentIndex = findIndex(visiblePages, { name: currentPage.name });

  return (
    <FlexDivSpaceBetweenCenter className="p-5">
      <SVButton
        variant="secondary"
        disabled={isFirstPage}
        onClick={() => onPageChanged(visiblePages[currentIndex - 1])}
      >
        Previous
      </SVButton>
      <SVButton
        variant="secondary"
        disabled={isLastPage}
        onClick={() => onPageChanged(visiblePages[currentIndex + 1])}
      >
        Next
      </SVButton>
    </FlexDivSpaceBetweenCenter>
  );
};

export default FooterNavigation;
